var getStateKey = function getStateKey(renderedElement) {
  return typeof renderedElement.ref === 'string' ? renderedElement.ref : renderedElement.key;
};

export default getStateKey;


//////////////////
// WEBPACK FOOTER
// ./~/radium/es/get-state-key.js
// module id = 508
// module chunks = 0